__turbopack_context__.v({
  "fade-in": "MediaGallery-module-scss-module__gRFewq__fade-in",
  "gallery": "MediaGallery-module-scss-module__gRFewq__gallery",
  "no-transform": "MediaGallery-module-scss-module__gRFewq__no-transform",
  "rotate": "MediaGallery-module-scss-module__gRFewq__rotate",
});
